import { CSSProperties } from 'react'
import { faCirclePlus, faPencil } from '@fortawesome/pro-light-svg-icons'
import { Button } from '@/ui'

export const AddButton = ({
  onClick,
  text,
  style,
}: {
  onClick: () => void
  text: string
  style?: CSSProperties
}) => (
  <Button
    onClick={onClick}
    variant="link"
    style={style}
    iconLeft={faCirclePlus}
  >
    {text}
  </Button>
)

export const EditButton = ({
  onClick,
  text,
  style,
}: {
  onClick: () => void
  text: string
  style?: CSSProperties
}) => (
  <Button onClick={onClick} variant="link" style={style} iconLeft={faPencil}>
    {text}
  </Button>
)
